import { render, staticRenderFns } from "./MaterialCircle.vue?vue&type=template&id=0a589173&scoped=true&"
import script from "./MaterialCircle.vue?vue&type=script&lang=js&"
export * from "./MaterialCircle.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCircle.vue?vue&type=style&index=0&id=0a589173&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a589173",
  null
  
)

export default component.exports